import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { Button } from './ui/Button';
import { Zap } from 'lucide-react';
export function StickyUrgencyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.querySelector('section');
      if (heroSection) {
        const heroBottom = heroSection.getBoundingClientRect().bottom;
        setIsVisible(heroBottom < 0);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-355">
      {isVisible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-night-950/95 backdrop-blur-md border-t border-purple-500/30 shadow-[0_-10px_30px_rgba(0,0,0,0.5)]" data-id="element-356">
          <div className="max-w-6xl mx-auto px-4 py-3 md:py-4 flex flex-col md:flex-row items-center justify-between gap-3 md:gap-6" data-id="element-357">
            <div className="flex flex-col md:flex-row items-center gap-2 md:gap-6 text-center md:text-left" data-id="element-358">
              <div className="flex items-center gap-2 text-sm md:text-base font-medium text-white" data-id="element-359">
                <Zap className="w-4 h-4 text-yellow-400" data-id="element-360" />
                <span data-id="element-361">Solo quedan 23 copias</span>
              </div>
              <div className="flex items-center gap-2 text-sm md:text-base" data-id="element-362">
                <span className="text-slate-400" data-id="element-363">Expira en:</span>
                <CountdownTimer className="text-lg md:text-xl" data-id="element-364" />
              </div>
            </div>

            <Button href="https://www.viventispace.com/cart/46127430566076:1" className="w-full md:w-auto px-6 py-2.5 md:px-8 md:py-3 text-sm md:text-base whitespace-nowrap" data-id="element-365">
              ¡Lo quiero! →
            </Button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}